module.exports = __webpack_public_path__ + "img/icon_footer_qrcode.020d81d4.png";